/**
 * @file: ControlPill.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The filter panel's tappable pill: an icon, the current selection, and a
 * chevron. Every control row in the panel is built from it, so the pills stay
 * the same height and share one hairline/surface treatment.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChevronDown } from 'lucide-react-native';
import { ReactNode, memo } from 'react';
import { TouchableOpacity } from 'react-native';

export const ControlPill = memo(
  ({
    icon,
    label,
    onPress,
  }: {
    icon: ReactNode;
    label: string;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={onPress}
        style={{
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          height: rpx(44),
          paddingHorizontal: rpx(14),
          borderRadius: rpx(12),
          backgroundColor: LD.surface,
          borderWidth: 1,
          borderColor: LD.hairline,
        }}
      >
        {icon}
        <Typography.Text
          size={rpx(14)}
          color={LD.ink}
          medium
          numberOfLines={1}
          style={{ flex: 1, marginLeft: rpx(8) }}
        >
          {label}
        </Typography.Text>
        <ChevronDown size={rpx(16)} color={LD.mist} />
      </TouchableOpacity>
    );
  },
);
